import writer from './writers/monitorWriter';

export { ConsoleMonitorWriter } from './writers/consoleMonitorWriter';
export { SolutoMonitorWriter } from './writers/solutoMonitorWriter';
export { default as monitorClient, MeasureTimeCallback } from './monitorClient';
export const setMonitorWriters = writer.setWriters;



// WEBPACK FOOTER //
// ./packages/platform-utils/monitoring/index.ts